import { render, staticRenderFns } from "./ScopeRulesEditor.vue?vue&type=template&id=1cebd550"
import script from "./ScopeRulesEditor.vue?vue&type=script&lang=js"
export * from "./ScopeRulesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports